import { combineReducers } from 'redux';
// Pre login auth fields
import auth from '../authentication/reducer';
// User profile details
import account from '../pilot-settings/pilot-profile/reducer';
import { credentialsReducer } from '../pilot-settings/credentials/credentials-reducer';
import { equipmentReducer } from '../pilot-settings/equipment/equipment-reducer';
// General application / user state
import onboarding from '../onboarding/reducer';
// TODO: What is stats?
import stats from '../stats/reducer';
import users from '../administration/users/reducer';
import { metaReducer } from '../meta/reducer';
import { seatsReducer } from '../administration/plan-and-usage/seats/seats-reducer';
import { assistantReducer } from '../assistant/reducer';

export default combineReducers({
  auth,
  account,
  assistant: assistantReducer,
  credentials: credentialsReducer,
  equipment: equipmentReducer,
  meta: metaReducer,
  onboarding,
  seats: seatsReducer,
  stats,
  users,
});
